import React, { useState, useImperativeHandle, forwardRef } from "react";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from '@mui/material/Alert';

export enum notificationType {
  Error = "error",
  Warning = "warning",
  Info = "info",
  Success = "success",
}


const Alert = (props: AlertProps) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const NotificationMessage = (props: any, ref: any) => {
  const [message, setMessage] = useState("");
  const [type, setType] = useState(notificationType.Info);
  const [open, setOpen] = useState(false);

  useImperativeHandle(
    ref,
    () => ({
      show(message: string, type?: notificationType) {
        showMessage(message, type);
      },
    }),
    []
  );

  const showMessage = (message: string, type?: notificationType) => {
    setMessage(message);
    if (type) {
      setType(type);
    }

    setOpen(true);
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <div>
      <Snackbar autoHideDuration={6000} open={open} 
        onClose={handleClose}
      >
        <Box>
          <Alert onClose={handleClose} severity={type}>
            {message}
          </Alert>
        </Box>
      </Snackbar>
    </div>
  );
};

export default forwardRef(NotificationMessage);
